import React from "react";
import { View, Platform, StyleSheet, ScrollView, Text } from "react-native";

import Header from "../../../common/header/index";
import appStyles from "../../../../appStyles";
import appPages from "../../../../../appPages";
import AppTheme from "../../../AppTheme";
import { MoodColors } from "../../../common/mood/MoodsHelper";
import CopyWidget from "../../common/CopyWidget";
import AppConfig from "../../../../../config/AppConfig";
import { openURL } from "../../../../../helpers/utils";

export default function Reconnect({ account, goBack = () => {} }) {
  const url = AppConfig.SLACK_DOWNLOAD_URL;

  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title="Reconnect Slack"
        subTitle={account}
        goBack={goBack}
        returnPage={appPages.integrationsV2}
      />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={styles.sectionText}>
          We’re having trouble connecting to your account
        </Text>

        <Text style={styles.label}>Reconnect Slack:</Text>

        <Text style={[styles.text]}>
          1. Start in a browser window that is logged into your Slack
          environment as an administrator, or ask your administrator to follow
          these steps.
        </Text>
        <Text
          style={[styles.text, styles.linkText, { marginTop: 16 }]}
          onPress={() => openURL(url)}
        >
          2. Click here to grant rights
        </Text>
        <Text style={styles.text}>
          or copy the link below into your browser:
        </Text>

        <CopyWidget
          text={url}
          style={{
            marginTop: 8,
            marginBottom: 16,
          }}
        />

        <Text style={[styles.text, { marginBottom: 8 }]}>
          3. For Mana to watch a channel, navigate to that channel, type ‘/add’,
          and choose ‘Add apps to this channel’
        </Text>

        <Text style={styles.text}>
          4. Click the “Add” button next to Mana.ai
        </Text>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginBottom: 8,
    marginTop: 16,
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  linkText: {
    color: AppTheme.DEFAULT_COLOR,
    fontWeight: "600",
    marginBottom: 8,
  },
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
    marginTop: 16,
    textAlign: "center",
  },
});
